import { NgModule } from '@angular/core';
import { FiDotLoaderComponent } from '@fi-shared/fi-dot-loader/fi-dot-loader.component';

@NgModule({
    imports: [],
    declarations: [FiDotLoaderComponent],
    exports: [FiDotLoaderComponent],
})
export class FiDotLoaderModule {}
